import { Node } from "@tiptap/core";
import { NodeViewContent, NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";
import { Trash2 } from "lucide-react";
import { cn } from "@/lib/utils";

export const TONES = [{ v: "sol", l: "Sol" }, { v: "ink", l: "Mørk" }, { v: "paper", l: "Lys" }];

const CalloutView = ({ node, updateAttributes, deleteNode, selected }) => (
  <NodeViewWrapper as="aside" data-type="callout" data-tone={node.attrs.tone} className={cn("hk-callout", selected && "is-selected")} data-testid="editor-callout">
    <div className="hk-block-tools" contentEditable={false}>
      <span className="hk-seg">{TONES.map((t) => <button key={t.v} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => updateAttributes({ tone: t.v })} className={cn(node.attrs.tone === t.v && "is-on")} data-testid={`editor-callout-tone-${t.v}`}>{t.l}</button>)}</span>
      <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={deleteNode} className="is-danger" title="Fjern faktaboksen" aria-label="Fjern faktaboksen" data-testid="editor-callout-remove"><Trash2 className="h-3.5 w-3.5" /></button>
    </div>
    <input value={node.attrs.title || ""} onChange={(e) => updateAttributes({ title: e.target.value })} placeholder="Overskrift (t.d. Godt å vite)" className="hk-callout-title" data-testid="editor-callout-title" />
    <NodeViewContent className="hk-callout-body" />
  </NodeViewWrapper>
);

/** <aside data-type="callout" data-tone data-title>…blocks…</aside> – «Faktaboks» for the practical bits. */
export const Callout = Node.create({
  name: "callout",
  group: "block",
  content: "block+",
  defining: true,
  draggable: true,
  addAttributes() {
    return {
      tone: { default: "sol", parseHTML: (el) => el.getAttribute("data-tone") || "sol" },
      title: { default: "", parseHTML: (el) => el.getAttribute("data-title") || "" },
    };
  },
  parseHTML() { return [{ tag: 'aside[data-type="callout"]' }]; },
  renderHTML({ node }) { return ["aside", { "data-type": "callout", "data-tone": node.attrs.tone, "data-title": node.attrs.title || null }, 0]; },
  addNodeView() { return ReactNodeViewRenderer(CalloutView); },
});
